import PropTypes from 'prop-types';
import {connect} from '@gisatcz/ptr-state';
import Select from '../../../../state/Select';
import {ValuesLegendItem} from '../../../atoms/Legend';

const VectorMapTooltip = ({
	layer,
	object,
	activeVisualization,
	activeAttribute,
}) => {
	const style = layer?.props?.options?.style?.rules[0]?.styles[1];
	const attributeKey = style.attributeKey;
	const attributeValues = style.attributeValues;
	const valueByClass =
		attributeValues?.[object?.properties?.[attributeKey]]?.name;

	return (
		<div className={'VectorMapTooltip-layer'}>
			<div>
				<h5>{activeVisualization.data.nameDisplay}</h5>
				<div>
					<ValuesLegendItem
						name={
							valueByClass ? valueByClass : object?.properties?.[attributeKey]
						}
						color={`rgb(${layer
							.getFeatureFill({}, attributeKey, object)
							.slice(0, -1)
							.join(',')})`}
					/>
					{activeAttribute?.data.unit ? (
						<div className="VectorMapTooltip-unit">
							[{activeAttribute?.data.unit}]
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};

VectorMapTooltip.propTypes = {
	layer: PropTypes.object,
	object: PropTypes.object,
	activeVisualization: PropTypes.object,
	activeAttribute: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
	return {
		activeVisualization: Select.insar.visualizations.getActive(state),
		activeAttribute: Select.attributes.getByKey(state, ownProps.attributeKey),
	};
};

export default connect(mapStateToProps)(VectorMapTooltip);
